import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex w-full flex-col items-center justify-center px-4 py-24 text-center md:py-32">
      <p className="font-heading text-7xl font-800 text-primary-200 md:text-9xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-700 text-foreground-950 md:text-3xl">
        这个页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        你要找的页面可能已被移除或链接有误。试试回到首页，继续发现好看的韩剧。
      </p>
      <p className="mt-2 font-label text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 hover:bg-primary-600 cursor-pointer">
          回到首页
        </Link>
        <Link to="/category/drama" className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-700 hover:bg-background-100 cursor-pointer">
          浏览剧集大全
        </Link>
      </div>
    </div>
  );
}